type SignatureStep = {
  id: number
  position: number
  title: string
}
type SignatureGroup = {
  id: number
  position: number
  steps: Array<SignatureStep>
}

export type SigningChecklistOrderState = {
  signatureGroupCreationPending: boolean
  signatureGroupDeletionPending: boolean
  signatureGroupMovingPending: boolean
  signatureGroups: Array<SignatureGroup>
  signatureGroupsLoadingPending: boolean
  signatureStepDeletionPending: boolean
  signatureStepMovingPending: boolean
}

export const state: SigningChecklistOrderState = {
  signatureGroupCreationPending: false,
  signatureGroupDeletionPending: false,
  signatureGroupMovingPending: false,
  signatureGroups: [],
  signatureGroupsLoadingPending: false,
  signatureStepDeletionPending: false,
  signatureStepMovingPending: false,
}
